/**
 * Small shared selection helpers used by both batch delete (index.ts) and group
 * transform (group-transform-service.ts).
 */

import type { SceneObject } from 'trace-viewer';

/**
 * Filter a selection to its top-most objects: drop any object that has an
 * ancestor also present in the selection.
 *
 * Such a descendant rides along under its in-selection ancestor, so operating on
 * it independently would double-apply — e.g. deleting an ancestor already removes
 * the descendant's subtree, and reparenting both under a group pivot would move
 * the descendant twice.
 */
export function topMostSelected(objects: readonly SceneObject[]): SceneObject[] {
    const set = new Set(objects);
    return objects.filter(obj => {
        for (let p = obj.getParent(); p; p = p.getParent()) {
            if (set.has(p)) return false;
        }
        return true;
    });
}
